import React from 'react';
import PropTypes from 'prop-types';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar/LayoutWithSidebar';

const withSidebar = (Component, options) => {
  function ComponentWithSidebar() {
    return (
      <LayoutWithSidebar
        Component={Component}
        withTabsBar={options?.withTabsBar}
      />
    );
  }

  return ComponentWithSidebar;
};

withSidebar.propTypes = {
  Component: PropTypes.node.isRequired,
  options: PropTypes.shape({
    withSidebar: PropTypes.bool,
  }),
};

withSidebar.defaultProps = {
  options: {
    withSidebar: false,
  },
};

export default withSidebar;
